import { useDispatch } from 'react-redux';

import { SearchQuery } from 'modules/domains';

import { updateQuery } from '../../actions';

export type SetRootQueryFn = (query: SearchQuery) => void;

export const useSetRootQuery = (): SetRootQueryFn => {
  const dispatch = useDispatch();
  return function setRootQuery(query: SearchQuery) {
    dispatch(updateQuery(query));
  };
};
